import React from 'react';
import { useTranslation } from 'react-i18next';
import Notification, { NotificationDuration, } from '../../../Notifications/Notification';
import SystemNotification from '../../../SystemNotification';
import Heading from '../../../a11y/headings/Heading';
import s from './GroupPromptNotification.scss';
var GroupPromptNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, removeNotification = _a.removeNotification;
    var t = useTranslation().t;
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, onClose: function () { return removeNotification(id); }, cardProps: {
            multiLine: true,
            withCloseButton: true,
            duration: NotificationDuration.M,
            closeButtonClassName: s['close-button'],
            className: s['root'],
            textClassName: s['text'],
            customIcon: (React.createElement("img", { className: s['icon'], alt: "IL44", src: "https://st.deviantart.net/eclipse/promos/il44.svg" })),
        } },
        React.createElement("div", { className: s['notification-text'] },
            React.createElement(Heading, { className: s['notification-heading'] }, t('deviationview.groupPrompt.title')),
            React.createElement("span", null, t('deviationview.groupPrompt.message')))));
};
GroupPromptNotification.displayName = 'GroupPromptNotification';
export default GroupPromptNotification;
//# sourceMappingURL=GroupPromptNotification.js.map